import React, { useState, useContext } from 'react';
import { LocalContext } from 'context';
import styled from 'styled-components';
import { KeynoteSpeakers, Speakers, EarlyInvestigators } from 'components';
import { AnimatePresence, motion } from 'framer-motion';
import { gridContainer, fullWidth } from 'styles';
import Arrow from 'assets/svgs/down-arrow.svg';

const AllSpeakers = () => {
  const { theme } = useContext(LocalContext);
  const [numberOfVisibleSpeakerContainers, setNumberOfVisibleSpeakerContainers] = useState(1);
  return (
    <Wrapper>
      <SpeakerContainer>
        <H3 style={{ textAlign: 'center', marginBottom: '50px' }} theme={theme}>
          Keynote Speakers
        </H3>
        <KeynoteSpeakers />
        <AnimatePresence>
          {numberOfVisibleSpeakerContainers < 2 && (
            <ClickToViewMoreSpeakers
              onClick={() => setNumberOfVisibleSpeakerContainers(2)}
              theme={theme}>
              <StyledArrow theme={theme} />
              Click to view more speakers
            </ClickToViewMoreSpeakers>
          )}
        </AnimatePresence>
      </SpeakerContainer>
      <AnimatePresence>
        {numberOfVisibleSpeakerContainers >= 2 && (
          <SpeakerContainer>
            <H3 style={{ textAlign: 'center', marginBottom: '50px' }} theme={theme}>
              Speakers
            </H3>
            <Speakers />
            <AnimatePresence>
              {numberOfVisibleSpeakerContainers < 3 && (
                <ClickToViewMoreSpeakers
                  onClick={() => setNumberOfVisibleSpeakerContainers(3)}
                  theme={theme}>
                  <StyledArrow theme={theme} />
                  Click to view more speakers
                </ClickToViewMoreSpeakers>
              )}
            </AnimatePresence>
          </SpeakerContainer>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {numberOfVisibleSpeakerContainers >= 3 && (
          <SpeakerContainer>
            <H3 style={{ textAlign: 'center', marginBottom: '50px' }} theme={theme}>
              Early Investigators
            </H3>
            <EarlyInvestigators />
          </SpeakerContainer>
        )}
      </AnimatePresence>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  ${gridContainer}
  display: flex;
  flex-direction: column;
  padding: 3rem 0;

  @media (min-width: 768px) {
    padding: 6rem 0 3rem;
  }

  @media (min-width: 1600px) {
    padding: 6rem 0 3rem;
  }
`;

const H3 = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.75rem;
  text-align: left;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.textColor};
  ${fullWidth}
  @media (min-width: 1600px) {
    grid-column: 3/11;
  }
`;

const SpeakerContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 1.5rem 0;

  @media (min-width: 768px) {
    padding: 2rem 0;
  }

  @media (min-width: 1600px) {
    padding: 4rem 0;
  }
`;

const ClickToViewMoreSpeakers = styled.span`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: ${({ theme }) => (theme.textColor === '#093248' ? '#eb5a30' : theme.textColor)};
  align-self: center;
  position: absolute;
  bottom: 1.375rem;
`;

const StyledArrow = styled(Arrow)`
  height: auto;
  margin-right: 1.25rem;
  min-width: 1rem;
  transform: ${({ open }) => (open ? 'scale(1, -1) translateY(-10px)' : 'none')};
  transition: 0.5s;
  width: 1rem;
  margin-bottom: 0.325rem;
  path {
    stroke: ${({ open, theme }) => (open ? '#bdbdbd' : theme.fg)};
  }
  @media (min-width: 48em) {
    width: 1.5rem;
  }
`;

export default AllSpeakers;
